<template>
  <div>
    <card-toolbar :title="$tc('settings')" />

    <v-tabs
      :ripple="false"
      v-model="selectedTab"
      slider-color="dinamo"
      background-color="transparent"
      centered
      show-arrows
      mobile-break-point="100px"
    >
      <v-tab v-for="tab in tabs" :id="`tab_${tab.id}`" :key="`tab-${tab.id}`">
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab" style="background: transparent;">
      <v-tab-item class="mt-4" v-if="canUserUpdateFirmware">
        <hsm-firmware-update-tab />
      </v-tab-item>

      <v-tab-item class="mt-4" v-if="canUserAccessRemoteLog">
        <bind-dinamo-services-tab />
      </v-tab-item>

      <v-tab-item class="mt-4" v-if="canUserAccessRemoteLog">
        <hsm-ip-filter-tab />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <hsm-tls-bundle-tab />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <hsm-snmp-tab />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <hsm-ntp-tab />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <hsm-dns-tab />
      </v-tab-item>

      <v-tab-item class="mt-4">
        <hsm-syslog-tab />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CardToolbar from '@/components/CardToolbar'
import PermissionsMixin from '@/mixins/permissions'

import BindDinamoServicesTab from './BindDinamoServicesTab.vue'
import HsmIpFilterTab from './HsmIpFilter/HsmIpFilterTab.vue'
import HsmFirmwareUpdateTab from './HsmFirmwareUpdateTab.vue'
import HsmTlsBundleTab from './HsmTlsBundleTab.vue'
import HsmSnmpTab from './HsmSnmp/HsmSnmpTab.vue'
import HsmNtpTab from './HsmNtp/HsmNtpTab.vue'
import HsmDnsTab from './HsmDns/HsmDnsTab.vue'
import HsmSyslogTab from './HsmSyslog/HsmSyslogTab.vue'

export default {
  mixins: [PermissionsMixin],
  components: {
    CardToolbar,
    BindDinamoServicesTab,
    HsmIpFilterTab,
    HsmFirmwareUpdateTab,
    HsmTlsBundleTab,
    HsmSnmpTab,
    HsmNtpTab,
    HsmDnsTab,
    HsmSyslogTab
  },
  data () {
    return {
      selectedTab: 0
    }
  },
  created () {
    this.$store.dispatch('hsm/getNetInfo')
    this.$store.dispatch('hsm/getStatInfo')
    this.$store.dispatch('hsm/getP11Info')

    if (this.$route.params.tab !== undefined) {
      this.selectedTab = this.$route.params.tab
    }
  },
  computed: {
    tabs () {
      const items = []

      if (this.canUserUpdateFirmware) {
        items.push({
          title: this.$tc('firmware_update'),
          id: 'firmware_update'
        })
      }

      if (this.canUserAccessRemoteLog) {
        items.push({
          title: this.$tc('bind_dinamo_services'),
          id: 'bind_dinamo_services'
        })

        items.push({
          title: this.$tc('ip_filter'),
          id: 'ip_filter'
        })
      }

      items.push({
        title: this.$tc('tls_bundle'),
        id: 'tls_bundle'
      })

      items.push({
        title: this.$tc('snmp'),
        id: 'snmp'
      })

      items.push({
        title: this.$tc('ntp'),
        id: 'ntp'
      })

      items.push({
        title: this.$tc('dns'),
        id: 'dns'
      })

      items.push({
        title: this.$tc('syslog'),
        id: 'syslog'
      })

      return items
    }
  }
}
</script>
